var map = {
	"./1.png": 3613,
	"./2.png": 3614,
	"./3.png": 3615,
	"./4.png": 3616
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 703;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/letters .\.png*
// module id = 703
// module chunks = 0